import { render } from "./initialQuestion.vue?vue&type=template&id=3c18b246"
import script from "./initialQuestion.vue?vue&type=script&lang=js"
export * from "./initialQuestion.vue?vue&type=script&lang=js"

import "./initialQuestion.vue?vue&type=style&index=0&id=3c18b246&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__